import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { frameworkActions } from "../state/FrameworkReducer.js";
import { DispatchAction } from "../state/State.js";
import { uiActions } from "../state/UiReducer.js";
import { leaders } from "../assets/script/leaders";
import { aspectColors } from "../assets/script/constants";

/**
 * @name SelectLeaderModal
 * @class SelectLeaderModal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class SelectLeaderModal extends ConnectedHTMLElement {
  constructor() {
    super();
  }

  getLeaderAspects(leader) {
    let aspects = "";
    leader.aspect.map((aspect) => {
      aspects += `<span style="background-color: ${aspectColors[aspect]}" class="inline-block base-color">&nbsp;</span>`;
    });
    return aspects;
  }

  leaderElementList() {
    const baseArr = leaders.map((leader) => {
      return `<li class="flex flex-row leader-item">
      ${this.getLeaderAspects(leader)}
    <button class="leader flex flex-row justify-between w-full p-2 ml-2" data-leader="${leader.id}"><span>${leader.name}</span></button>
    </li>`;
    });

    return baseArr.join("");
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (newState.ui.showLeaderModal.show !== oldState.ui.showLeaderModal.show) {
      this.render();
    }
  }

  registerElementEvents() {
    const player = this.state.ui.showLeaderModal.player;
    const modal = this.querySelector("#select-leader-modal");
    const leaderItems = this.querySelectorAll(".leader");
    const closeBtn = this.querySelector("#close");

    closeBtn.addEventListener("click", () => {
      DispatchAction(uiActions.toggleSelectLeader, { show: false, player });
    });

    leaderItems.forEach((button) => {
      button.addEventListener("click", (event) => {
        const selectedLeader = leaders.find(
          (b) => b.id === button.dataset.leader
        );
        DispatchAction(frameworkActions.setLeader, {
          leader: selectedLeader,
          player,
        });
        DispatchAction(uiActions.toggleSelectLeader, { show: false, player });

        modal.close();
      });
    });
  }

  render() {
    const player = this.state.ui.showLeaderModal.player;
    if (player === "none") {
      this.innerHTML = "";
      return;
    }

    this.innerHTML = `
        <dialog class="modal ${player === "top" ? "rotate-180" : ""}" id="select-leader-modal" ${this.state.ui.showLeaderModal.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Select your leader</h3>
            <ul id="leader-list">
              ${this.leaderElementList()}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }

  dispatchEvent(event) {
    return false;
  }
}
